import { Injectable } from '@angular/core';

import { EpcotConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ConfirmationDialogService } from '@frontend/sports/modal/feature';

import { BetslipAutoCloseDialogService } from './betslip-auto-close-dialog.service';

@Injectable()
export class EditBetPicksAddedInfoDialogService extends BetslipAutoCloseDialogService {
    constructor(
        private confirmationDialogService: ConfirmationDialogService,
        private sitecore: Sitecore,
        private epcotConfig: EpcotConfig,
    ) {
        super();
    }

    show(): void {
        const epcotClass = this.epcotConfig.isEnabled ? 'epcot-enabled' : '';
        const ref = this.confirmationDialogService.showDialog({
            title: '',
            message: this.sitecore.betslip.editBet.selectionAddedInfo,
            buttons: [],
            cssClass: `edit-bet__selection-added-info betslip-vars-scope ${epcotClass}`,
            icon: 'betslip-icon theme-success-i',
            backdropClass: 'edit-bet__selection-added-info__backdrop',
        });
        this.onShow(ref);
    }
}
